export default __webpack_public_path__ + "static/media/16.b9f71315.mp3";